<div *ngIf="photosUrl; else elseBlock">
    <div class="simple-image-view-block">
        <img [src]="photosUrl.src" [alt]="photosUrl.alt" [title]="photosUrl.alt" class="img-responsive"/>
    </div>
</div>
<ng-template #elseBlock>
    <div class="simple-image-view-no-image-block"></div>
</ng-template>
